import PropTypes from "prop-types";
import React from "react";

// Custom Loaders
import LineInputsLoader from "../LineInputsLoader";

// MUI
import { Divider, Grid, Skeleton, Stack } from "@mui/material";

// Constants
const minInputsAmount = 3;

export default function CustomerSatisfactionLoader(props) {
	const [tiers, setTiers] = React.useState(2);
	const [buttonsAmount, setButtonsAmount] = React.useState(1);
	const [inputsAmount, setInputsAmount] = React.useState(minInputsAmount);

	React.useEffect(() => {
		if (props.tiers) {
			setTiers(props.tiers);
		}
		if (props.buttonsAmount) {
			setButtonsAmount(props.buttonsAmount);
		}
		if (props.inputsAmount) {
			setInputsAmount(props.inputsAmount);
		}
		return () => {
			setTiers(2);
			setButtonsAmount(1);
			setInputsAmount(minInputsAmount);
		};
	}, [props]);

	return (
		<Grid direction={"column"} container mt={1} sx={props.sx || null}>
			{props.title && (
				<Grid item>
					<Skeleton variant="text" width={200} height={25} />
				</Grid>
			)}

			<Grid item mt={1}>
				<Skeleton variant="rectangular" width={100} height={35} sx={{ borderRadius: "6px" }} />
			</Grid>

			<Grid item mt={1}>
				{Array.from(Array(tiers)).map((_, key) => {
					const itemKey = `csi_loader_${key}`;
					return (
						<Stack key={itemKey} direction={"row"} spacing={2} mt={0.5}>
							<Stack direction={"column"} justifyContent={"center"} alignItems={"center"} spacing={1}>
								{!key && <Skeleton variant="text" width={80} height={20} />}
								<Skeleton variant="rectangular" width={80} height={30} sx={{ borderRadius: "25px" }} />
							</Stack>
							<Stack direction={"column"} justifyContent={"center"} alignItems={"center"} spacing={1}>
								{!key && <Skeleton variant="text" width={150} height={20} />}
								<Skeleton variant="rectangular" width={300} height={30} sx={{ borderRadius: "6px" }} />
							</Stack>
							<Stack
								direction={"column"}
								justifyContent={"center"}
								alignItems={"center"}
								spacing={1}
								sx={{ marginLeft: "25px !important" }}
							>
								{!key && <Skeleton variant="text" width={0} height={20} />}
								<Skeleton variant="circular" width={32} height={32} />
							</Stack>
						</Stack>
					);
				})}
			</Grid>

			{props.buttons && (
				<Grid container item direction={"row"} mt={0.5} justifyContent={"center"} spacing={2} width={512}>
					{Array.from(Array(buttonsAmount)).map((_, key) => {
						const itemKey = `csi_btn_loader_${key}`;
						return (
							<Grid item key={itemKey}>
								<Skeleton variant="rectangular" width={100} height={25} sx={{ borderRadius: "6px" }} />
							</Grid>
						);
					})}
				</Grid>
			)}

			{props.inputs && (
				<Grid container item width={500}>
					<LineInputsLoader title inputsAmount={inputsAmount} />
				</Grid>
			)}

			{props.switch && (
				<Grid container item direction={"row"} mt={2} mr={1} spacing={2}>
					<Grid item xs={12}>
						<Stack mb={2}>
							<Divider className="!border-disabled w-full" />
						</Stack>
						<Stack direction={"row"} justifyContent={"flex-end"} alignItems={"center"} spacing={1}>
							<Skeleton variant="text" width={200} height={20} />
							<Skeleton variant="rectangular" width={45} height={22} sx={{ borderRadius: "15px" }} />
						</Stack>
					</Grid>
				</Grid>
			)}
		</Grid>
	);
}
CustomerSatisfactionLoader.propTypes = {
	tiers: PropTypes.number,
	buttonsAmount: PropTypes.number,
	inputsAmount: PropTypes.number,
	title: PropTypes.bool,
	buttons: PropTypes.bool,
	inputs: PropTypes.bool,
	switch: PropTypes.bool,
	sx: PropTypes.object,
};
